var app = {
  init: function init() {}
};
$("document").ready(app.init);